import cart from "@/domain/icon/svg/cart";
import linkExternal from "@/domain/icon/svg/link-external";
import trash from "@/domain/icon/svg/trash";
import qrCode from "@/domain/icon/svg/qr-code";
import faceHappy from "@/domain/icon/svg/faceHappy";
import download from "@/domain/icon/svg/download";
import chevronLeft from "@/domain/icon/svg/chevron-left";
import chevronRight from "@/domain/icon/svg/chevron-right";
import menu from "@/domain/icon/svg/menu";
import plusCircle from "@/domain/icon/svg/plus-circle";
import plus from "@/domain/icon/svg/plus";
import globe from "@/domain/icon/svg/globe";
import faceId from "@/domain/icon/svg/faceId";
import copy from "@/domain/icon/svg/copy";
import cameraShutter from "@/domain/icon/svg/camera-shutter";
import dotsVertical from "@/domain/icon/svg/dotsVertical";
import eye from "@/domain/icon/svg/eye";
import eyeSlash from "@/domain/icon/svg/eyeSlash";
import reload from "@/domain/icon/svg/reload";
import alertTriangle from "@/domain/icon/svg/alert-triangle";
import infoCircle from "@/domain/icon/svg/info-circle";
import bank from "@/domain/icon/svg/bank";
import stripe from "@/domain/icon/svg/stripe";
import closeCircle from "@/domain/icon/svg/close-circle";
import edit from "@/domain/icon/svg/edit";
import notificationMessage from "@/domain/icon/svg/notification-message";
import send from "@/domain/icon/svg/send";
import arrowLeft from "@/domain/icon/svg/arrow-left";
import close from "@/domain/icon/svg/close";
import creditCards from "@/domain/icon/svg/credit-cards";
import play from "@/domain/icon/svg/play";
import arrowNarrowUpRight from "@/domain/icon/svg/arrow-narrow-up-right";
import chevronRightDouble from "@/domain/icon/svg/chevron-right-double";
import chevronLeftDouble from "@/domain/icon/svg/chevron-left-double";
import expand from "@/domain/icon/svg/expand";
import phone from "@/domain/icon/svg/phone";
import heart from "@/domain/icon/svg/heart";
import imagePlus from "@/domain/icon/svg/image-plus";
import reloadCw from "@/domain/icon/svg/reload-cw";
import arrowRight from "@/domain/icon/svg/arrow-right";
import magicWand from "@/domain/icon/svg/magic-wand";

export const _icons = {
    magicWand,
    arrowRight,
    reloadCw,
    imagePlus,
    heart,
    phone,
    cart,
    linkExternal,
    download,
    trash,
    qrCode,
    faceHappy,
    chevronLeft,
    chevronRight,
    menu,
    plusCircle,
    plus,
    globe,
    faceId,
    copy,
    cameraShutter,
    dotsVertical,
    eye,
    eyeSlash,
    reload,
    alertTriangle,
    infoCircle,
    bank,
    stripe,
    closeCircle,
    edit,
    notificationMessage,
    send,
    arrowLeft,
    close,
    creditCards,
    play,
    arrowNarrowUpRight,
    chevronRightDouble,
    chevronLeftDouble,
    expand
}